import styled from "styled-components";

export type DynamicHeadingConfig = {
  titleTag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
} & React.HTMLAttributes<HTMLHeadingElement>;

export const DynamicHeading = styled.h1.attrs<DynamicHeadingConfig>(
  ({ titleTag }) => ({
    as: titleTag,
  })
)<DynamicHeadingConfig>`
`;
